/*************************************************************************
*
*  Copyright 2022 Adobe
*  All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

export const RENDITION_SCRIPT_NAME = "rendition.js";

export const REVIEW_TYPE = "/review";
export const PARCEL_TYPE = "/parcel";
export const EXTERNAL_TYPE = "/external";
export const SIGN_TYPE = "/sign";
export const ACP_TYPE = "/acp";
export const PDFNOW_TYPE = "/pdfnow";
export const CONNECTOR_ASSET_TYPES = ["/onedrive", "/sharepoint", "/gdrive", "/local"];
export const CONNECTOR_TYPES_BY_ASSET_TYPE = Object.freeze({
    "/onedrive": "OneDrive",
    "/sharepoint": "SharePoint",
    "/gdrive": "GDrive",
    "/local": "Local",
});

export const DCAPI_PDF_METADATA_MAX_RETRIES = 10;
export const DCAPI_METADATA_MAX_RETRIES = 5;
export const DCAPI_NON_PDF_METADATA_MAX_RETRIES = 30;
export const DCAPI_PDF_RENDITION_MAX_RETRIES = 10;
export const RETRY_INTERVAL = 1000;
export const RETRY_INTERVAL_NON_PDF = 1500;
export const CACHE_SIZE = 500;

export const downloadUrlType = Object.freeze({
    S3: "S3",
    DCAPI: "DCAPI",
    NONE: "NONE",
});

export const DCAPI_REDIRECT_URL_MAX_RETRIES = 1;

export const perfMarkers = Object.freeze({
    PDF_DOWNLOAD_URI_START: "pdfDownloadUriStartTime",
    PDF_DOWNLOAD_URI_END: "pdfDownloadUriEndTime",
    PDF_DOWNLOAD_START: "pdfDownloadStartTime",
    PDF_DOWNLOAD_END: "pdfDownloadEndTime",
    DCAPI_INIT: "dcapiInit",
    DCAPI_LOADED: "dcapiLoaded",
    WASM_SPLIT_FLOODGATE_START: "wasmSplitFloodgateStart",
    WASM_SPLIT_FLOODGATE_END: "wasmSplitFloodgateEnd",
    CACHED_RENDITION_RETURNED: "cachedRenditionReturned",
    CACHED_RENDITION_FAILED: "cachedRenditionFailed",
    CACHED_RENDITION: "cachedRendition",
});

export const VALIDATOR_NAME = Object.freeze({
    AdobeSignValidator: "AdobeSignCertificateValidator",
    ExternalValidator: "ExternalCertificateValidator",
});

export const VALIDATION_STATUS = Object.freeze({
    valid: "VALID",
    invalid: "INVALID",
    unknown: "UNKNOWN",
});

export const VALIDATION_TIME = Object.freeze({
    currentTime: "currentTime",
    signingTime: "signingTime",
});

export const TRUST_SOURCE = Object.freeze({
    AATL: "AATL",
    EUTL: "EUTL",
    OS: "OS",
});

export const HTTP_ERROR_STRINGS = Object.freeze({
    tooManyRequests: "TooManyRequests",
    gatewayTimeout: "GatewayTimeout",
    internalServerError: "InternalServerError",
    apiTimeoutError: "APITimeoutError",
    unknownError: "UnknownError",
});

export const DEFAULT_AJS_INSTANCE_KEY = "defaultAJSInstance";
export const MAX_ACTIVE_AJS_INSTANCE_LIMIT = 10;

export const ANONYMOUS_USER = "anonymous_user";
